'use strict';

function CompanyPublicationShareService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/shares/:shareId', {companyId: '@companyId', publicationId: '@publicationId', shareId: '@shareId'}, {
  	'sendEmailAgain': {
      method: 'POST',
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/shares/send-email/:shareId'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyPublicationShareService', ['$resource', 'config', CompanyPublicationShareService]);




//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationShareService.js
// module id = 381
// module chunks = 0